export default __webpack_public_path__ + "d8b9fc85d3ef01504a372840effb07c7.svg";